// create hook for get opportunities
import { updateOpportunities } from "@/helpers/apis";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  GET_IMPLEMENTED_OPPORTUNITIES_DATA,
  GET_OPPORTUNITIES_DATA,
  GET_OPPORTUNITY_DETAIL,
  GET_PRIORITY_OPPORTUNITIES_DATA,
} from "./constants";

// A single status (or owner) mutation can affect every /discover surface
// that lists or details an opportunity:
//   - /opportunities/             (Opportunities tab)
//   - /opportunities/implemented  (Implemented Opportunities tab)
//   - Priority tab + opportunity detail page
// Centralize cache invalidation here so every consumer stays in sync
// without having to remember which keys to flush.
const INVALIDATE_KEYS = [
  GET_OPPORTUNITIES_DATA,
  GET_IMPLEMENTED_OPPORTUNITIES_DATA,
  GET_PRIORITY_OPPORTUNITIES_DATA,
  GET_OPPORTUNITY_DETAIL,
] as const;

export const useOpportunities = () => {
  const queryClient = useQueryClient();
  // @ts-ignore
  const mutation = useMutation({
    mutationFn: updateOpportunities,
    onSuccess: () => {
      INVALIDATE_KEYS.forEach(key =>
        queryClient.invalidateQueries({ queryKey: [key] })
      );
    },
  });

  return { mutation };
};
